import React from 'react';
import { 
    Edit, 
    useDataProvider,
    Loading, 
    useGetOne,  } from 'react-admin';
import CourseInputs from './CourseInputs';
import { ShowTitleByTitle } from '../Scaffolding';
import { toSavedRepresentation } from '../../utils/courseDelivery';
import { QualificationTitle } from './QualificationTitle';
import { useParams } from 'react-router-dom';


const CourseEdit = (props) => {
    const dataProvider = useDataProvider();

    const transform = async (data) => {
        const { data: courseInstancesForCourse } =
            await getCourseInstancesForCourse(dataProvider, data.id);

        const courseDeliveries = data.courseDeliveries || [];

        for (let courseDeliveryItem of courseDeliveries ) {
            if (courseDeliveryItem.copyOf !== undefined) {
                const { copyOf, ...courseDelivery } = courseDeliveryItem;

                const courseInstancesWithSameDelivery =  courseInstancesForCourse.filter(courseInstance => matchesCopiedDelivery(courseInstance, data.courseDeliveries[copyOf]));
                for (let courseInstance of courseInstancesWithSameDelivery) {
                    const newCourseInstance = {
                        ...courseInstance,
                        id: '',
                        courseDelivery: toSavedRepresentation(courseDelivery),
                    };
                    await dataProvider.create('CourseInstance', {
                        data: newCourseInstance,
                    });
                }
                delete courseDeliveryItem.copyOf;
            }
        }
        return {
            ...data,
        };
    };

    const params = useParams();
    let resource = "Course";
    if(params.id?.length > 10){
        resource = "ThisSpecificCourseVersion"
    }

    const { data, isLoading, error, } = useGetOne(resource, { id: params.id })
    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    if (data) {
        return (
            <Edit
            title={<QualificationTitle />}
            {...props}
            redirect="edit"
            transform={transform}>
            <CourseInputs {...props} />
        </Edit>
        )
    }

};

async function getCourseInstancesForCourse(dataProvider, courseId) {
    return await dataProvider.getList('CourseInstance', {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'id', order: 'DESC' },
        filter: {
            courseId: courseId,
        },
    });
}

function matchesCopiedDelivery(courseInstance, courseDelivery) {
    if (!courseInstance.courseDelivery) return false;

    try {
        let instanceCourseDelivery = JSON.parse(
            courseInstance.courseDelivery
                .replace(/\\"/g, '"')
                .replace(/'/g, '"')
        );

        return (
            JSON.stringify(instanceCourseDelivery) ===
            JSON.stringify(courseDelivery)
        );
    } catch {
        // Ignore error and return false
        return false;
    }
}

export default CourseEdit;
